import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.41827 14.2412L1.66663 5.83331L6.66663 8.33331L9.99996 3.33331L13.3333 8.33331L18.3333 5.83331L16.5816 14.2412C16.3884 15.1687 15.571 15.8333 14.6237 15.8333H5.37623C4.42888 15.8333 3.61149 15.1687 3.41827 14.2412Z",
      stroke: "#DD8833",
      "stroke-width": "2",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }